var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import _ from 'lodash';
import { Component } from 'vue-property-decorator';
import { currMonthDefaultDate } from '../../helper/defaultDate';
import PurchaseReportForUpperSupService from '../../api/PurchaseReportForUpperSupService';
import TableList from '../../components/common/TableList.vue';
import Header from './components/PurchaseDetailHeader.vue';
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.service = PurchaseReportForUpperSupService.getInstance();
        _this.fetchAction = _this.service.getDetailReportList;
        _this.sortColumns = [
            'supplier_upper_name',
            'organ_name',
            'supplier_goods_name',
            'order_detail_money',
            'upper_purchase_order_code',
            'order_code',
            'warehouse_date',
        ];
        _this.filter = {
            order_from: 1,
            time_type: 1,
            supplier_upper_id: [],
            keyword_type: 1,
            goods_type_id: [],
            keyword: '',
            s_time: currMonthDefaultDate().Start.format('yyyy-MM-dd'),
            e_time: currMonthDefaultDate().End.format('yyyy-MM-dd'),
        };
        return _this;
    }
    List.prototype.search = function (filter) {
        var _this = this;
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
        }
        if (_.isDate(filter.e_time)) {
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        if (!filter.s_time) {
            this.$message.error('请选择开始时间');
            return;
        }
        if (!filter.e_time) {
            this.$message.error('请选择结束时间');
            return;
        }
        this.filter = filter;
        this.filter.supplier_upper_id = (this.filter.supplier_upper_id || []).filter(function (item) { return !(typeof item === 'string' && item.indexOf('category_id') > -1); });
        this.filter.supplier_upper_id = (this.filter.supplier_upper_id || []).join(',');
        this.filter.goods_type_id = this.filter.keyword_type == '1' ? (this.filter.goods_type_id || []).join(',') : '';
        this.$nextTick(function () {
            _this.$refs.TableList.fetch();
        });
    };
    List = __decorate([
        Component({
            components: {
                'list-header': Header,
                TableList: TableList,
            },
        })
    ], List);
    return List;
}(Vue));
export default List;
